import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createProjectWorkflow,
  deleteProjectWorkflow,
  getProjectWorkflow,
  getProjectWorkflows,
  updateProjectWorkflow
} from '../../api/project-workflows';
import { WorkflowParam } from '../Project/ProjectView';

export const getProjectWorkflowsAsync = createAsyncThunk(
  'projectWorkflows/getProjectWorkflows',
  getProjectWorkflows
);

export const getProjectWorkflowAsync = createAsyncThunk(
  'projectWorkflows/getProjectWorkflow',
  getProjectWorkflow
);

export const createProjectWorkflowAsync = createAsyncThunk(
  'projectWorkflows/createProjectWorkflow',
  createProjectWorkflow
);

export const updateProjectWorkflowAsync = createAsyncThunk(
  'projectWorkflows/updateProjectWorkflow',
  updateProjectWorkflow
);

export const deleteProjectWorkflowAsync = createAsyncThunk(
  'projectWorkflows/deleteProjectWorkflow',
  async (
    {
      workflowId,
      workflowParams
    }: { workflowId: number; workflowParams: WorkflowParam },
    thunkAPI
  ) => {
    await deleteProjectWorkflow(workflowId);
    thunkAPI.dispatch(getProjectWorkflowsAsync(workflowParams));
  }
);

export interface ProjectWorkflow {
  id: number;
  name: string;
  disciplineId: number;
  projectId: number;
  project?: {
    id: number;
    projectRegisterId: number;
  };
  discipline?: {
    id: number;
    name: string;
    cfihosName: string;
  };
  projectWorkflowSteps: {
    id: number;
    projectWorkflowId: number;
    workflowStepId: number;
    projectApprovalWorkflowSteps: {
      id: number;
      userId: number;
    }[];
  }[];
  isCreatorViewOnlyExternal: boolean;
  isCreatorViewOnlyFinal: boolean;
}

interface ProjectWorkflowState {
  data: ProjectWorkflow[];
  selectedProjectWorkflow: ProjectWorkflow | null;
}

const initialState: ProjectWorkflowState = {
  data: [],
  selectedProjectWorkflow: null
};

export default createSlice({
  name: 'projectWorkflows',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProjectWorkflowsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(getProjectWorkflowAsync.fulfilled, (state, action) => {
      state.selectedProjectWorkflow = action.payload;
    });
  }
});
